import ChromeIcon from '@images/chrome.svg?react';
import EdgeLogo from '@images/edge.svg?react';
// import QESG_AssessmentLogo from '@images/QESG_Assessment_basic.svg?react';
import QESG_CarbonLogo from '@images/QESG_Carbon_basic.svg?react';
import i18n from '@/i18n';

function AuthCard({ children }) {
  return (
    <div className="bg-white shadow-sm rounded-2">
      <div className="d-flex align-items-center justify-content-center border-bottom text-center px-3 py-4">
        <QESG_CarbonLogo className="w-100 h-100" style={{ maxWidth: '160px' }} />
      </div>
      <div className="border-bottom p-3">{children}</div>
      {i18n.language === 'ko' && (
        <div className="p-3">
          <div className="bg-light rounded-bottom-2 p-3">
            본 시스템은
            <a
              href="https://www.google.com/intl/ko/chrome/"
              className="d-inline-flex align-items-center"
            >
              <ChromeIcon className="ms-2 me-2" style={{ width: '17px', height: '17px' }} />
              Google Chrome
            </a>
            <span className="mx-md-2">또는</span>
            <br className="d-block d-md-none" />
            <a
              href="https://www.microsoft.com/ko-kr/edge"
              className="d-inline-flex align-items-center"
            >
              <EdgeLogo className="me-2" style={{ width: '17px', height: '17px' }} />
              Microsoft Edge
            </a>{' '}
            에 최적화되어있습니다.
          </div>
        </div>
      )}

      {i18n.language === 'en' && (
        <div className="p-3">
          <div className="bg-light rounded-bottom-2 p-3">
            This system is optimized for
            <a
              href="https://www.google.com/intl/ko/chrome/"
              className="d-inline-flex align-items-center"
            >
              <ChromeIcon className="ms-2 me-2" style={{ width: '17px', height: '17px' }} />
              Google Chrome
            </a>
            <span className="mx-md-2">or</span>
            <br className="d-block d-md-none" />
            <a
              href="https://www.microsoft.com/ko-kr/edge"
              className="d-inline-flex align-items-center"
            >
              <EdgeLogo className="me-2" style={{ width: '17px', height: '17px' }} />
              Microsoft Edge
            </a>
          </div>
        </div>
      )}

      {i18n.language === 'zh' && (
        <div className="p-3">
          <div className="bg-light rounded-bottom-2 p-3">
            本系统已针对
            <a
              href="https://www.google.com/intl/ko/chrome/"
              className="d-inline-flex align-items-center"
            >
              <ChromeIcon className="ms-2 me-2" style={{ width: '17px', height: '17px' }} />
              Google Chrome
            </a>
            <span className="mx-md-2">或</span>
            <br className="d-block d-md-none" />
            <a
              href="https://www.microsoft.com/ko-kr/edge"
              className="d-inline-flex align-items-center"
            >
              <EdgeLogo className="me-2" style={{ width: '17px', height: '17px' }} />
              Microsoft Edge
            </a>{' '}
            进行优化。
          </div>
        </div>
      )}
    </div>
  );
}

export default AuthCard;
